<script setup>
import { ModalsContainer } from 'vue-final-modal';
import { useScrollLock } from '@/composables/useScrollLock';
import { useGlobalStore } from '@/stores/global';
import { useCustomBreakpoints } from '@/composables/useCustomBreakpoints';

const { lock: lockScroll, unlock: unlockScroll } = useScrollLock();
const route = useRoute();

const globalStore = useGlobalStore();

const { md: isBreakpointUpMd } = useCustomBreakpoints();

watch(isBreakpointUpMd, (value) => {
  if (value && globalStore.isMobileMenuShow) {
    globalStore.closeMobileMenu();
  }
});

watch(
  () => route.hash,
  () => {
    closeMobileMenu();
  },
);

function closeMobileMenu() {
  globalStore.closeMobileMenu();
}

function onBeforeEnter() {
  lockScroll();
}

function onBeforeLeave() {
  unlockScroll();
}
</script>

<template>
  <CResize class="layout-wrapper">
    <div class="layout-wrapper__slot">
      <slot />
    </div>

    <Transition
      name="slide-fade"
      @before-enter="onBeforeEnter"
      @after-leave="onBeforeLeave"
    >
      <div
        v-if="globalStore.isMobileMenuShow"
        class="layout-wrapper__wrapper layout-wrapper__wrapper--mobile-menu"
        data-scroll-lock-scrollable
      >
        <LayoutMobileMenu
          v-click-outside="closeMobileMenu"
          class="layout-wrapper__mobile-menu"
        />
      </div>
    </Transition>

    <ModalsContainer />
  </CResize>
</template>

<style scoped lang="scss">
.layout-wrapper {
  $parent: &;

  position: relative;
  display: flex;
  flex-direction: column;

  &__slot {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__mobile-menu {
  }

  &__wrapper {
    &--mobile-menu {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5;
      width: 100vw;
      height: 100vh;
      padding-top: em(80);
      overflow: auto;
    }
  }
}
</style>
